module.exports = {
  i: {
    locale: 'ja-JP',
    select: {
      placeholder: '選んでください',
      noMatch: 'マッチするデータなし',
      loading: 'ロード中'
    },
    table: {
      noDataText: 'データなし',
      noFilteredDataText: 'スクリーニングしたデータなし',
      confirmFilter: 'スクリーニング',
      resetFilter: 'リセット',
      clearFilter: '全部'
    },
    datepicker: {
      selectDate: '日時を選んでください',
      selectTime: '時間を選んでください',
      startTime: 'スタート時間',
      endTime: '終了時間',
      clear: 'クリーア',
      ok: '確定',
      datePanelLabel: '[yyyy年] [m月]',
      month: '月',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      year: '年',
      weekStartDay: '0',
      weeks: {
        sun: '日',
        mon: '月',
        tue: '火',
        wed: '水',
        thu: '木',
        fri: '金',
        sat: '土'
      },
      months: {
        m1: '1月',
        m2: '2月',
        m3: '3月',
        m4: '4月',
        m5: '5月',
        m6: '6月',
        m7: '7月',
        m8: '8月',
        m9: '9月',
        m10: '10月',
        m11: '11月',
        m12: '12月'
      }
    },
    transfer: {
      titles: {
        source: 'ソースリスト',
        target: 'ターゲットリスト'
      },
      filterPlaceholder: '検索内容を入力ください',
      notFoundText: '内容が見つかってなかった'
    },
    modal: {
      okText: '確定',
      cancelText: 'キャンセル'
    },
    poptip: {
      okText: '確定',
      cancelText: 'キャンセル'
    },
    page: {
      prev: '前へ',
      next: '次へ',
      total: '全部',
      item: '件',
      items: '件',
      prev5: '前の５ページへ',
      next5: '次の５ページへ',
      page: '件/ページ',
      goto: '',
      p: 'ページ目へ'
    },
    rate: {
      star: '点',
      stars: '点'
    },
    tree: {
      emptyText: 'データなし'
    },
    login: {
      username : 'ユーザー名',
      password :'パスワード',
      domain: '領域を選択してください',
      verificationCode:'検証コード',
      administrators: '管理人登録',
      language:'言語',
      language_zh:'中国語',
      language_ja:'日本語',
      user_message:'ユーザー名を入力してください',
      password_message:'パスワードを入力してください',
      password_length_message: 'パスワードの長さは8位ではありません',
      verificationCode_message:'検証コードを入力してください',
      examinationLanding: '研修システム登録',
      land: '登録',
      functionalClassification: '機能',
      rules: '本部及び自社規程',
      research: '研 修',
      examination: 'テスト',
      testResume: '受講履歴',
      news: 'ニュース',
      loginData: '必須アイテムを入力してください',
      PersonalInformation: '個人情報管理',
      isInitPasswd: '初期パスワードを変更してください。',
      passwdExpired: 'パスワードの有効期限が切れています。パスワードを変更してください。',
      area: '请选择国家地区',
      mobile: '携帯番号を入力してください',
      oldPassword: '元のパスワードを入力してください',
      newPassword: '新しいパスワードを入力してください',
      newPasswordC: '新しいパスワードを入力してください',
      forgetThePassword: 'パスワードを忘れた場合',
      mobileVerificationCode: '携帯電話の検証コード',
      resetPassword: 'パスワードを再設定',
      getPhoneVerificationCode: '携帯電話の検証コードを取得',
      recapture: '後に再取得',
      gePhoneNumber: '携帯電話の検証コードを取得',
      company: '请选择公司',
      mobileCaptcha: '携帯電話の検証コードを入力してください',
      passwdEq: '两次密码不同，请重新输入！',
      LoginMsg: 'システムを登録してください',
      returnHome: 'トップページに戻る',
      returnPrevious: '前頁',
      pwdQuestion:'パスワード保護に関する質問',
      pwdAnswer:'パスワード保護に関する回答',
      pwdForgetType:'パスワードを取り戻す方式',
      pwdForgetMsg:'パスワードを取り戻せるため、携帯番号又はパスワード保護に関する質問の1個を選んで、ご入力ください。',
      pwdForgetWarn:'パスワード保護に関する質問を入力してください',
      pwdForgetTypeMsg:'パスワードを取り戻す方式を入力してください',
      noAuthEntry: 'アクセス権がありません'
    },
    system :{
      name:'Honda研修システム',
      news:'最新ニュース',
      personNews: '個人通知',
      pleaseReadFrontImg: '先に前の章を読んでください',
      pleaseWait: '十分読んでから次のページを読んでください',
      examinationSystem: '研修システム',
      hondaChina: '本田技研工業（中国）投資有限会社',
      examinationRecords: '受講履歴',
      signOut: 'ログアウト',
      administration: '管理',
      study: '研修',
      details: '詳細',
      online: 'オンライン',
      face: '現場',
    },
    studyModule: {
      newPersonStudy: '新人研修',
      manageStudy: '管理職研修',
      studyDetail: '研修の詳細'
    },
    studyColumn: {
      depName: '部署',
      isMe: '管理者かどうか',
      name: '名前',
      endDate: '研修締切日',
      studyStatus: '状態',
      studyName: '研修名称',
      bbOrzs: '本部/自社',
      obj: '対象者',
      desrc: '概要',
      isFinish: '研修状態',
      date: '日付',
      signature: '状態',
      signatureNo: '申し込みがない',
      signature0: '審査中',
      signature1: '審査待ち',
      signature2: '审核通过',
    },
    contacts: {
      title: '問い合わせ窓口',
      name: '本田技研工業（中国）投資有限会社',
      department: '法務部'
    },

    resume: {
      testResume : '受講履歴',
      studyTrain: '研修の経歴',
      examinationRecords: '受講履歴',
      listOfResume: '履歴一覧'
    },
    common : {
      research: '研修',
      examination: 'テスト',
    },
    test : {
      testPaper: '行動規範試験用紙について',
      propose: '提出',
      safekeeping: '保管する',
      answerDescrRight: 'ご回答おめでとうございます',
      answerDescrWrong: '申し訳ございませんが、失礼ですが',
      answerDescr:'正解',
      answer:'答えが詳しい',
      passExamination: '完了',
      examinationValidityPeriod: '試験がまだ始まっていないか、または試験の締め切りを超えている',
      reExamination: '再試験',
      saveOk: '保存成功',
      Yes:'⚪',
      No:'X',
      determine:'判定',
      preservation:'中止して保存',
      testNotPass: '全問正解ではないため、再テストとなります!',
      seeImg:'画像の表示'
    },
    search : {
      selfSocialRegulation: '本部及び自社規程の発行',
      name: '名 称',
      operation: '操作する',
      legalConstitution: '本部及び法律規程'
    },
    news : {
      all: '全部',
      yes: '既読',
      no: '未読',
    },
    exam : {
      single: '単選問題',
      multi: '多選問題',
      judge: '判断問題',
      fill: '穴を埋める',
      ask: '問答問題',
      msg:'答えがない',
      message:'試験問題に答えてください',
    },
    courseware : {
      toExam: 'テスト実施',
      name: '研修名称',
      signUpSuccess: '申し込みが成功した',
      signUp: '申し込む',
      examination: 'テスト名',
      title: 'タイトル',
      startDate: '開始時間',
      dep: '部署',
      orgName: '所属機関',
      course_architecture_names: '本部/自社',
      courseType: '種類',
      operation: ' ',
    },
    resumeRecord :{
      number: 'NO',
      user: '氏名',
      title: '研修名',
      score: '得点',
      answerTimes: '受講回数',
      theEndTime: '最終試験時間',
      status: '状態',
      isPass: '研修状況',
      year: '年度',
      search: '検索',
      staffNumber: '従業員番号',
      staffInstitution: '部門名称',
      lastLearningTime: '最後の勉強時間',
      derive: 'エクスポート',
      noChoice: '選択されていません',
      complete: '完了',
      noStart: '開始していません',
      noComplete: '未完成'
    },
    isFinish: {
      finish: '完了しました',
      noFinish: '未完成'
    },
    isPass :{
      yes: '完了',
      no: '未完了'
    },
    resumeStatus :{
      yes: '提出',
			no: '未提出',
    },
    changePassword:{
      password: 'パスワード修正',
      cellPhoneNumber: '携帯番号',
      originalPassword: 'パスワード',
      newPassword: '新しいパスワード',
      confirmPassword: '新しいパスワード再入力',
      preservation: '保存',
      title: '注：パスワードを忘れた場合、携帯電話へコードを発信すること又はパスワード保護に関する質問を回答することを通してパスワードを取り戻せるため、携帯番号又はパスワード保護に関する質問の1個を選んで、ご入力ください。'
    },
    SelectChapter:{
      chapter_name: '章の名前',
      file_size: 'ファイルサイズ'
    },
    personalInformation: {
      modifyInformation: '個人情報修正',
      changePassword: 'パスワード修正',
      domain: '領域',
      typeOfCompany: '会社',
      viewLearningRecords: '学習履歴',
      departmentName: '所属部門',
      chineseName: '中国語の名前',
      japaneseName: '日本語の名前',
      age: '年齢',
      email: 'メールアドレス',
      phoneNumber: '携帯番号',
      phoneAreaVal:'区号',
    },
    domains:{
      nbkzqy: '内部統制領域',
      rsly: '人事領域',
      itly: 'IT領域',
    },
    viewLearningRecords: {
      courseName: 'コース名',
      courseType: 'レッスンタイプ',
      itsCurriculumSystem: '所属コース',
      completeState: '完了状態',
      lastLearningTime: '最後の勉強時間',
      schedule: '進度'
    },
    studyModelData: {
      name1: '研修申込',
      name2: '研修実施',
      yes: 'は',
      no:'いいえ'
    },
    jj: {
      jj: 'コンテンツ',
      btn:'個人情報保護・データセキュリティ/企業倫理改善提案窓口',
      name:'資料名',
      type:'分類',
      zt:'特集',
      download:'ダウンロード',
      content:'説明',
      title1:'個人情報保護<br>データセキュリティ',
      title2:'企業倫理改善提案窓口'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/ja-JP.js